export default function PHP_xml_get_current_byte_index() {
  return (
    <div>
      <h1>PHP_xml_get_current_byte_index</h1>
    </div>
  );
}
